import { toastError } from "../../utils/toast";
import { useCallback, useState } from "react";
import type React from "react";
import type { AttachedConversation } from "@common/types/conversation-attachments";

export const ATTACHED_CONVERSATIONS_PATH = "/api/conversation-attachments-conversations";

export interface UseChatChromeInputs {
  webappFetch: (url: string, options?: RequestInit) => Promise<any>;
  conversationId: string;
  attachedConversationsRevision: React.MutableRefObject<number>;
  setAttachedConversationsByConversationId: React.Dispatch<React.SetStateAction<Record<string, AttachedConversation[]>>>;
}

export function useChatChrome({ webappFetch, conversationId, attachedConversationsRevision, setAttachedConversationsByConversationId }: UseChatChromeInputs) {
  const [showFilesPanel, setShowFilesPanel] = useState(false);
  const handleRemoveConversation = useCallback(async (attachedConversationId: string) => {
    try {
      await webappFetch(
        `${ATTACHED_CONVERSATIONS_PATH}?conversationId=${conversationId}&attachedConversationId=${attachedConversationId}`,
        { method: "DELETE" },
      );
      attachedConversationsRevision.current += 1;
      setAttachedConversationsByConversationId((prev) => ({
        ...prev,
        [conversationId]: (prev[conversationId] ?? []).filter((c) => c.id !== attachedConversationId),
      }));
    } catch (error) {
      toastError(error);
    }
  }, [conversationId, webappFetch, attachedConversationsRevision, setAttachedConversationsByConversationId]);
  return { showFilesPanel, setShowFilesPanel, handleRemoveConversation };
}
